import DeliveryChallanList from '../components/DeliveryChallanList';

const JWDeliveryChallan = () => {
  return <DeliveryChallanList type="JW" title="JW Delivery Challan" />;
};

export default JWDeliveryChallan;
